import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Card from "react-bootstrap/Card";
import styles from "../../styles/styles.css";

const Awards = () => {
    const data = useStaticQuery(graphql`
        {
            dataYaml {
                about {
                    awards {
                        title
                        items {
                            title
                            organization
                            year
                        }
                    }
                }
            }
        }
    `).dataYaml.about.awards;

    const awards = data.items.map((award, key) => (
        <li key={key}>
            {award.title} - {award.year} | {award.organization}
        </li>
    ));

    return (
        <Card className={styles.card}>
            <Card.Header className={styles.cardHeader}>
                {data.title}
            </Card.Header>
            <Card.Body>
                <ul>{awards}</ul>
            </Card.Body>
        </Card>
    );
};

export default Awards;
